module.exports = __webpack_public_path__ + "static/foto-36dd522996e4f27312c96d90886e36f6.png";